__turbopack_context__.v({
  "actions": "ConfirmDeleteModal-module__k9ylHa__actions",
  "cancel": "ConfirmDeleteModal-module__k9ylHa__cancel",
  "delete": "ConfirmDeleteModal-module__k9ylHa__delete",
  "message": "ConfirmDeleteModal-module__k9ylHa__message",
  "modal": "ConfirmDeleteModal-module__k9ylHa__modal",
  "overlay": "ConfirmDeleteModal-module__k9ylHa__overlay",
  "title": "ConfirmDeleteModal-module__k9ylHa__title",
});
